module.exports = __webpack_public_path__ + "img/commerce3.d813ef9f.png";